var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('i',{staticClass:"get_login",on:{"click":_vm.checkRecords}}),_c('i',{staticClass:"rule_btn",on:{"click":function($event){_vm.$parent.popShow = 'help'}}}),_c('i',{staticClass:"start_btn",on:{"click":_vm.goTransform}})])
}
var staticRenderFns = []

export { render, staticRenderFns }